// Initializes the WHOIS lookup form: intercepts submit, queries the result via
// fetch, and renders it into #whois-result. The form keeps a no-JS GET fallback,
// so this only enhances submission.
//
// Guarded against double-binding so it is safe to call again after a Turbo visit
// (see site/on-ready.js), part of the migration off rails-ujs (#35411).
//
// @param {ParentNode} [root=document] subtree to search for the form
// @returns {void}
export function init(root = document) {
  const form = root.querySelector('#whois-form');
  if (!form || form.dataset.whoisFormInitialized) return;

  form.dataset.whoisFormInitialized = 'true';

  const result = document.querySelector('#whois-result');
  const queryUrl = form.dataset.queryUrl;

  const showMessage = (message) => {
    result.replaceChildren();
    const div = document.createElement('div');
    div.className = 'tw:text-center';
    div.textContent = message;
    result.appendChild(div);
  };

  // WHOIS responses are untrusted text: render with textContent only.
  const showResult = (text) => {
    result.replaceChildren();
    const pre = document.createElement('pre');
    pre.className = 'tw:bg-graphite tw:text-white monospace tw:text-base tw:rounded-lg';
    pre.textContent = text;
    result.appendChild(pre);
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    showMessage('Please wait...');

    const id = form.querySelector('input[name=id]').value;
    const params = new URLSearchParams({ id });

    try {
      const response = await fetch(`${queryUrl}?${params}`);

      if (response.ok) {
        const data = await response.json();
        showResult(data.result);
      } else if (response.status === 422) {
        const data = await response.json();
        showMessage(data.error);
      } else
        showMessage(await response.text());

    } catch {
      showMessage('Something went wrong. Please try again.');
    }
  });
}

export default { init };
